import React from 'react';
import { Line } from 'react-chartjs-2';
import PropTypes from 'prop-types';
import { VerticalLine, GradientLine, HorizontalLine, MaxText } from './plugins';

const DrawGraph = props => {
    const graphData = () => {
        return {
            labels: props.xlabels,
            datasets: [
                {
                    data: props.graphData,
                    fill: false,
                    borderWidth: 4,
                    pointHighlightFill: '#fff',
                    pointRadius: 0,
                    pointStyle: 'circle',
                    pointHoverRadius: 6,
                    pointBackgroundColor: '#FFFFFF'
                }
            ]
        };
    };
    const plugins = [VerticalLine, GradientLine, HorizontalLine, MaxText];

    const options = {
        linearGradientThreshold: props.exceedLimit,
        linearGradientMax: props.yaxis,
        plugins: {
            legend: {
                display: false
            },
            hover: {
                mode: 'nearest',
                intersect: true
            },
            tooltip: props.tooltip
        },
        scales: {
            x: {
                grid: {
                    display: false
                }
            },
            y: {
                beginAtZero: true,
                grid: {
                    color: function(context) {
                        if (context.tick.value >= props.yaxis) {
                            return '#AD0034';
                        }
                        return '#DFE2E6';
                    },
                    borderDash: [4, 8]
                },
                ticks: {
                    callback: function(value) {
                        return value === props.exceedLimit ? '' : value;
                    },
                    stepSize: props.step
                }
            }
        },
        layout: {
            padding: {
                left: 25
            }
        }
    };

    return <Line data={graphData} options={options} plugins={plugins}></Line>;
};

DrawGraph.displayName = 'DrawGraph';
DrawGraph.propTypes = {
    /**
      exceed limit for gradient
     */
    exceedLimit: PropTypes.number,
    /**
    Data that show uses to create graph
    */
    graphData: PropTypes.array,
    /**
    step size for Y-Axis
    */
    step: PropTypes.number,
    /** 
    tooltip on point in graph 
    */
    tooltip: PropTypes.object,
    /**
     Array data for X-Axis
     */
    xlabels: PropTypes.array,
    /**
    Max number for Y-Axis
    */
    yaxis: PropTypes.number
};
export default DrawGraph;
